/**
 * Admin-only audit trail. Maps to apps/common/views/audit.py::AuditLogViewSet.
 */

import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { AuditLogEntry, Paginated } from "@/types/api";

export function useAuditLog() {
  return useQuery<Paginated<AuditLogEntry>>({
    queryKey: ["audit-log"],
    queryFn: async () => {
      const r = await api.get<Paginated<AuditLogEntry>>("/v1/audit-log/");
      return r.data;
    },
  });
}
